import styled from 'styled-components';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

import { Text18 } from '../../ui/Text18';
import { Text32 } from '../../ui/Text32';
import { Title } from '../../ui/Title';

export const Wrapper = styled.div`
  margin-top: 80px;
`;

export const AcceptLabel = styled(Text18)`
  margin-bottom: 0;
  font-weight: 700;
`;

export const AmountWrapper = styled.div`
  margin-top: 48px;
`;

export const AmountText = styled(Text32)``;

export const ButtonWrapper = styled.div`
  margin-top: 32px;
  width: 300px;
`;

export const AcceptWrapper = styled.div`
    display: flex;
    align-items: flex-start;
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Content = styled.div`
  width: 90%;
  max-width: 1400px;
  min-width: 320px;
`;

export const PageTitle = styled(Title)`
  margin-top: 64px;
`;

export const SelectedCard = styled.div`
  background-color: ${({ theme }) => theme.colors.lightGray};
  padding-bottom: 24px;
`;

export const UserInfoWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.gray};
  display: flex;
  justify-content: center;
  gap: 20px;
  align-items: center;
  border-radius: 8px;
  height: 72px;
  margin-top: 24px;
`;

export const Icon = styled(MailOutlineIcon)`
  color: ${({ theme }) => theme.colors.accentBlue};
`;

export const Text = styled(Text18)`
  font-weight: 700;
`;

export const TouristDataWrapper = styled.div`
  margin: 0 32px;
  margin-bottom: 24px;
`;

export const Row = styled.div`
  display: flex;
  gap: 20px;
`;

export const Bold = styled.span`
  font-weight: 700;
`;

export const ClientResponsability = styled(Text18)`
  margin: 32px 0 0 0;
  color: ${({ theme }) => theme.colors.darkGray};
`;